import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth';
import { inject } from '@angular/core';

export const memberMatchGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router)
  const authService = inject(AuthService)
  const decoded = authService.getDecodedToken()
  const userGroups: string[] = Array.isArray(decoded?.['cognito:groups']) ? decoded['cognito:groups'] : [];
  
  if(userGroups.indexOf('member') > -1) {
    return true;
  }
  
  return router.navigateByUrl(`/not-authorized`)
};
